/**
 *  版权所有 © 2026 东方闻道 All Rights Reserved
 *
 *  创建者: admin
 *  创建时间: 2026-09-20 16:23
 *  文件名: src/constant/common.ts
 *  功能描述:
 */

/**
 * 开放学校应用ID
 */
const APP_CODE = 'Openlearning';

export { APP_CODE };
